import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface classroomEndMeetingPayload {
  meetingIds: string[];
  meetingRole: string;
}

export default function useClassroomEndMeetingApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, classroomEndMeetingPayload> {
  return useMutation<any, unknown, classroomEndMeetingPayload>(
    async (payload: classroomEndMeetingPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/end_classroom_meeting/',
        payload,
      );
      console.log('Retrieved end_classroom_meeting = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch end_classroom_meeting data:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
